// request for lazy loading for all pages

export default class tableRequest {
    IsActive = '1';
    PageNo = 1;
    First = 1;
    SearchValue = "";
    PageSize = 5;
    SortColumn = "";
    SortOrder = "DESC";
    ProductId = 0;
    WareHouseId = 0;
    UserId = 0;
    FromDate = "";
    ToDate = "";
    UserType = 0;
    IsAccepted = ""; //for stock use
    IsWareHouse = true;
    Prefix ="";
    isPreprinted=false
}